import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useQuery } from 'react-apollo';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { LOGO_LARGE_WHITE, routeConstants } from '../../../utils';
import { GET_UNSEEN_MESSAGES } from '../../../graphql-client/queries';
import SendInvite from '../../modals/SendInvite';

function Sidebar(props) {
  const {
    artistRequestCount, managerRequestCount, analyticsPostCount, betaPostRequest, offerRequest,
  } = props;
  const [sendInviteModal, setSendInviteModal] = useState(false);
  const { data: unSeenMessagesData } = useQuery(GET_UNSEEN_MESSAGES);
  const location = useLocation();
  const pathName = location.pathname;

  const checkNewRequest = (count) => {
    let returnBadge = null;
    if (count > 0) {
      returnBadge = <span className="request-badge">New request</span>;
    }
    return returnBadge;
  };

  const toggleSendInviteModal = () => {
    setSendInviteModal(!sendInviteModal);
  };

  const checkNewPost = (count) => {
    let returnBadge = null;
    if (count > 0) {
      returnBadge = <span className="request-badge">New Post</span>;
    }
    return returnBadge;
  };

  return (
    <div className="sidebar">
      <div className="sidebar-wrapper">
        <div className="sidebar-logo">
          <img src={LOGO_LARGE_WHITE} alt="BYGmusic" />
        </div>
        <ul className="sidebar-nav">
          <li className={`sidebar-nav-offer ${routeConstants.ADMIN_OFFER === pathName ? 'active' : ''}`}>
            <Link to={`${routeConstants.ADMIN_OFFER}`}>Opportunities</Link>
            <span
              className={`icon icon-message ${unSeenMessagesData && unSeenMessagesData.unseenMessages.find((el) => el.unseenMessage) && 'unread'}`}
            />
            <span className={`icon icon-user ${offerRequest > 0 && 'unread'}`} />
            <span className={`icon icon-request ${betaPostRequest > 0 && 'unread'}`} />
          </li>
          <li className={routeConstants.ADMIN_ARTIST === pathName ? 'active' : ''}>
            <Link to={`${routeConstants.ADMIN_ARTIST}`}>
              Artists
              {checkNewRequest(artistRequestCount)}
            </Link>
          </li>
          <li className={routeConstants.ADMIN_MANAGER === pathName ? 'active' : ''}>
            <Link to={`${routeConstants.ADMIN_MANAGER}`}>
              Labels
              {checkNewRequest(managerRequestCount)}
            </Link>
          </li>
          <li className={routeConstants.ADMIN_ANALYTICS === pathName ? 'active' : ''}>
            <Link to={`${routeConstants.ADMIN_ANALYTICS}`}>
              Analytics
              {checkNewPost(analyticsPostCount)}
            </Link>
          </li>
          <Button
            type="button"
            color="send-invite"
            onClick={toggleSendInviteModal}
          >
            Send Invite
          </Button>
        </ul>
      </div>
      {sendInviteModal && (
        <SendInvite
          isOpen={sendInviteModal}
          onClose={() => { toggleSendInviteModal(); }}
        />
      )}
    </div>
  );
}
Sidebar.propTypes = {
  artistRequestCount: PropTypes.number,
  managerRequestCount: PropTypes.number,
  analyticsPostCount: PropTypes.number,
  betaPostRequest: PropTypes.number,
  offerRequest: PropTypes.number,
};

Sidebar.defaultProps = {
  artistRequestCount: 0,
  managerRequestCount: 0,
  analyticsPostCount: 0,
  betaPostRequest: 0,
  offerRequest: 0,

};

export default Sidebar;
